<template>
    <div class="tablea-div">
        
        <div class="handle-div" v-if="handleOff">
            <Button class="buttons" size='small' type="info" @click="addRow">添加</Button>
            <Button class="buttons" size='small' type="error" @click="delRow">删除</Button>
            <!-- <Button class="buttons" size='small' type="info" @click="chajge">显示</Button> -->
            <!-- <Button class="buttons" size='small' type="info" @click="llls">fdsdsf</Button> -->
        </div>
        <table  border="1" style="border-collapse: collapse;padding: 5px ;" cellpadding='10'>
            <tr>
                <th v-if="offCheck"><Checkbox @on-change='changeAll' v-model="allCheck"></Checkbox></th>
                <th v-if='offNum' style="width: 40px;">序号</th>
                <th v-for="(item,index) in titleRow" :style="`width:${item.widths?item.widths:''}px`"  :key="index" v-if="item.$type != '2'">{{item.name}}</th>
            </tr>
            <tr class="tr-div" v-for="(item,index) in tableList" :key="index">
                <td v-if="offCheck"><Checkbox v-model="item.check"></Checkbox></td>
                <td v-if="offNum">{{index+1}}</td>
                <td v-for="(item2,index2) in titleRow" :key="index2" v-if="item2.$type != '2'">
                    <span v-if="item2.type == 'text'">{{item[item2.title]}}</span>
                    <input style="border:0; resize: none;" v-else-if="item2.type == 'input'" @change="changeV(item,index)" type="text" v-model="item[item2.title]" placeholder="" name="" id="">
                    <textarea style="border:0; resize: none;" v-else-if="item2.type == 'textarea'" v-model="item[item2.title]" placeholder=""></textarea>
                    <DatePicker style="border:0; resize: none;"  v-else-if="item2.type == 'date'" :value="item[item2.title]" type="date" placeholder="请选择日期"></DatePicker>
                    <Select style="border:0; resize: none;"  v-else-if="item2.type == 'select'" v-model="item[item2.title]">
                        <Option v-for="(itemSl,indexSl) in item2.array_data" :value="itemSl.name" :key="indexSl">{{ itemSl.name }}</Option>
                    </Select>
                    <TimePicker v-else-if="item2.type == 'time_pick'" format="HH:mm" type="timerange" placement="bottom-end" placeholder="请选择时间" ></TimePicker>
                    <SearchModel  v-else-if="item2.type == 'part_name_model'" :checkVal='item[item2.title_id]'  :isMultiple='2'  :url="config.urlArray.expensesProducts" labelNameNew='model' labelName='name' valName='id' keyword="keyword" @setSelected='setSelected($event,item2.other_key,index,item2)'></SearchModel>
                </td>
            </tr>
            <tr v-if="tableList.length<=0">
                <td class="kong-td" colspan='100'>暂无数据</td>
            </tr>
            <tr v-if="totalArr">
                <td v-for="(item,index) in totalArr" :key="index"  :colspan="item.col_span">
                    <span v-if="item.key == '$total$'">{{item.name}}</span>
                    <span v-else>{{item.val}}</span>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
/**
 * text input textarea date select
 */

export default {
    props:{
        titleRow:{ //标题字段
            type: Array,
            default: []
        },
        handleOff: { //是否显示操作按钮
            type: Boolean,
            default: false
        },
        tableData:{
            type: Array,
            default: []
        },
        offNum:{ //是否显示序号
            type: Boolean,
            default: false
        },
        offCheck:{  //是否显示多选框
            type: Boolean,
            default: false
        },
        totalArrData:{
            type: [Array,Object]
        }
    },
    data(){
        return{
            tableList:[],
            totalArr:[],
            allCheck: false
        }
    },
    created(){
            let list = this.tableData
            list.map((item,index)=>{
                item.check = false
                return item
            })
            this.tableList = list
            this.calc()
    },
    methods:{
        setSelected(data,valKey,index,item2){
            console.log('item2.title_id]',item2.title_id)
            if(item2.title_id){
                this.tableList[index][item2.title_id] = data.nameVal
            }
            new Promise((resolve,reject)=>{
                for(let key in valKey){
                    console.log(key)
                    this.tableList[index][key] = data.nowData[valKey[key]]
                    // this.$set(this.tableList[index], key, data.nowData[valKey[key]])
                    // this.$forceUpdate()
                }
                resolve(true)
            }).then(()=>{
                console.log(this.tableList)
                this.methList(this.tableList)
                // this.$forceUpdate()
            })
            
        },
        checkNum(nubmer) {
            let re = /^[0-9]+.?[0-9]*/;//判断字符串是否为数字//判断正整数/[1−9]+[0−9]∗]∗/
        　　if (!re.test(nubmer)) {
        　　　　return 0
        　　}else{
                return nubmer
            }
        },
        calc(){
            console.log('totalArrData',this.totalArrData)
            if(this.totalArrData) {
               console.log('this.tableList',this.tableList)
                this.totalArr = this.totalArrData
                this.totalArr.map((item,index)=>{
                    item.val = 0
                    this.tableList.map((item2,index2)=>{
                        if(item.key != '$total$'){
                        item2[item.key] = this.checkNum( Number(item2[item.key]))
                        
                        item.val += Number(item2[item.key])
                        
                        }
                        return item
                    })
                    return item
                }) 
            }
            
        },
        chajge(){
        },
        changeAll(val){
            this.tableList.map((item,index)=>{
                item.check = val
                return item
            })
            this.$emit('setList',this.tableList)
            this.methList(this.tableList)
        },
        addRow(){
            let Obj = {}
             this.titleRow.map((item,index)=>{
                 if(item.$type == '2'){
                    Obj[item.title] = item.name
                 }else{
                    Obj[item.title] = ''
                 }
                 
            })
            this.tableList.push(Obj)
             this.methList(this.tableList)
        },
        delRow(){
            let newArr = []
            new Promise((resolve,reject)=>{
                this.tableList.map((item,index)=>{
                    if(!item.check){
                        newArr.push(item)
                    }
                })
                newArr.map((item,index)=>{
                    item.check = false
                    return item
                })
                this.tableList = []
                resolve(true)
            }).then(()=>{
                this.tableList = newArr
                this.methList(this.tableList)
            })
        },
        changeV(){
            this.calc()
        },
        async methList(list){
            this.$emit('setList',list)
            await this.calc()
        }
    }
}
</script>
<style lang="scss" scoped>
.handle-div{
    display: flex;
    align-items: center;
    margin: 10px 0px;
    .buttons{
        margin: 0px 5px 0px 0px;
    }
}
.tablea-div{
    table{
        width: 100%;
    }
}
.tr-div{
    th{
        padding: 2px 5px; 
        box-sizing: border-box;
    }
    td{
        padding: 2px 5px; 
        box-sizing: border-box;
        text-align: left;
        // display: flex;
        // justify-content: center;
        input,textarea{
            width: 100%;
            word-break: break-all;
            border:0;outline:none;
            resize: none;
        }
    }
}
input,textarea{
    word-break: break-all;
    border:0 !important;outline:none !important;
    resize: none !important;
}
</style>


